import React from "react";
import Skillcard from "./Skillcard";
import Skills from "./data/Skills";
import "./About.css";
import { motion } from "framer-motion";

const About = () => {
  const about_variants = {
    hidden: {
      opacity: 0,
    },
    visible: {
      opacity: 1,
      transition: {
        dealy: 0.2,
        duration: 0.6,
      },
    },
    exit: {
      opacity: 0,
      transition: {
        ease: "easeInOut",
      },
    },
  };
  return (
    <motion.div
      className="about"
      variants={about_variants}
      initial="hidden"
      animate="visible"
      exit="exit"
    >
      <h6 className="about__intro">
        Hello <>👋</> ! I Am Computer Science Student Who Loves Building Website And
        WebApps and Love Coding <> 🤍 </>.
      </h6>
      <div className="container about__container">
        <h6 className="about__heading">What I Offer !</h6>
        <div className="row">
          {Skills.map((Skills) => (
            <Skillcard skill={Skills} />
          ))}
        </div>
      </div>
    </motion.div>
  );
};

export default About;
